import { useQuery } from '@tanstack/react-query'

import { apiCheckSealedItemStock } from '@/payment/api'

import { PAYMENT_KEYS } from '../keys'

/**
 * 밀봉비닐 봉투 재고/판매여부 체크.
 *
 * 진입 분기와 CTA 검증 양쪽에서 사용. 매 호출마다 최신 상태가 필요해 staleTime 0.
 */
export const useGetSealedItemStock = () =>
  useQuery({
    queryKey: [PAYMENT_KEYS.SEALED_ITEM_STOCK],
    queryFn: apiCheckSealedItemStock,
    staleTime: 0,
  })
